import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoDropdown, DiscoIcon, DiscoIconKinds, DiscoTextSkeleton } from "@disco-ui"
import DiscoDropdownItem from "@disco-ui/dropdown/DiscoDropdownItem"
import { TestIDProps } from "@utils/typeUtils"

export type DiscoPaginatedDropdownProps = TestIDProps & {
  title: string
  icon?: DiscoIconKinds
  content: React.ReactNode
}

function DiscoPaginatedDropdown({
  testid = "DiscoPaginatedDropdown",
  title,
  icon,
  content,
}: DiscoPaginatedDropdownProps) {
  const classes = useStyles()

  return (
    <DiscoDropdown
      testid={testid}
      className={classes.dropdown}
      menuClasses={{ paper: classes.menu }}
      isNested
      mountChildrenOnOpen
      menuButton={({ onClick, isOpen }) => (
        <DiscoDropdownItem
          testid={`${testid}.dropdown-button`}
          title={title}
          icon={icon ? <DiscoIcon icon={icon} /> : undefined}
          selected={isOpen}
          onClick={onClick}
          rightButton={<DiscoIcon className={classes.chevron} icon={"chevron"} />}
        />
      )}
    >
      {content}
    </DiscoDropdown>
  )
}

export function DiscoPaginatedDropdownSkeleton(
  props: Partial<Pick<DiscoPaginatedDropdownProps, "title" | "icon">>
) {
  const { title, icon } = props
  const classes = useStyles()

  return (
    <DiscoDropdown
      className={classes.dropdown}
      menuClasses={{ paper: classes.menu }}
      isNested
      mountChildrenOnOpen
      menuButton={({ onClick, isOpen }) => (
        <DiscoDropdownItem
          title={title || <DiscoTextSkeleton width={"100%"} />}
          icon={icon ? <DiscoIcon icon={icon} /> : undefined}
          selected={isOpen}
          onClick={onClick}
          rightButton={<DiscoIcon className={classes.chevron} icon={"chevron"} />}
        />
      )}
    >
      <></>
    </DiscoDropdown>
  )
}

const useStyles = makeUseStyles((theme) => ({
  menu: {
    width: "100%",
    maxWidth: "500px",
    height: "460px",
    padding: `${theme.spacing(0, 2, 1.5, 2)} !important`,
    "& li": {
      height: "unset !important",
    },
  },
  chevron: {
    transform: "rotate(90deg)",
    marginLeft: theme.spacing(3),
  },
  dropdown: {
    maxHeight: "460px",
  },
}))

export default DiscoPaginatedDropdown
